var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('Slice',[_c('h1',[_vm._v("Page not found")]),_c('SuperButton',{attrs:{"to":"search"}},[_c('p',[_vm._v("Search instead")]),_c('Icon',{attrs:{"type":"arrow"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }